import { useParams, useNavigate } from "react-router-dom";
import { MatchPage as MatchPageView } from "@/components/MatchPage";

export function MatchPage() {
  const { billId } = useParams<{ billId: string }>();
  const navigate = useNavigate();

  if (!billId) return null;

  return (
    <MatchPageView
      billId={billId}
      onBack={() => navigate(-1)}
      onPurchaseOrderClick={(poId) => navigate(`/purchase-orders/${poId}`)}
      onDeliveryNoteClick={(dnId) => navigate(`/delivery-notes/${dnId}`)}
      onViewBill={() => navigate(`/bills/${billId}`)}
    />
  );
}
